<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="200"
      size="mini"
      resizable
      border
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('form_title_store') || '采购需求店铺SKU明细' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
          </div>
        </slot>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    amzPurchaseDemandCode: { type: String, default: '' },
    amzPurchaseDemandSkuCode: { type: String, default: '' }
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.getData()
        }
      },

      tableColumns: tableColumns(this)
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    headerCellStyle() {
      return {
        backgroundColor: '#bd94c1',
        color: '#ffffff'
      }
    },
    getData() {
      if (!this.amzPurchaseDemandCode || !this.amzPurchaseDemandSkuCode) return
      this.loading = true
      this.$api
        .ecomAmzPurchaseDemandStoreListApi({
          amzPurchaseDemandSkuCode: this.amzPurchaseDemandSkuCode
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
